import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getFromStorage } from 'src/lib/storage';
import { editConditionByIdAction } from 'src/modules/SuperAdmin/store/actions/condition.action';
import { SuperAdminModal } from '../../../baseComponents';
import * as Yup from 'yup';

const EditCondition = ({ isOpen, setIsOpen, isfilterOn, filterValue }) => {
  const dispatch = useDispatch();

  const cachedUserEmail = getFromStorage(`user_email`);
  const { getConditionById } = useSelector((state) => state?.conditionState);
  const { getAllSpecialtiesList } = useSelector(
    (state) => state?.specialtyState
  );
  const { appointmentTypeValues } = useSelector(
    (state) => state?.appointmentState
  );
  const [appointmentTypes, setAppointmentTypes] = useState([]);
  const [radioButtonValue, setRadioButtonvalue] = useState(1);
  const [specialtyOptions, setSpecialtyOptions] = useState([]);
  const [, setStoreConditionType] = useState('');
  const [storeSpecialtyId, setStoreSpecialtyId] = useState(null);

  useEffect(() => {
    setRadioButtonvalue(
      getConditionById?.appointment_type_id
        ? getConditionById?.appointment_type_id
        : 1
    );
  }, [getConditionById]);

  useEffect(() => {
    if (appointmentTypeValues && Array.isArray(appointmentTypeValues)) {
      const dataArr = appointmentTypeValues.map((item) => ({
        value: item?.appointment_type_id,
        label: item?.appointment_type_text,
      }));
      setAppointmentTypes(dataArr);
    }
  }, [appointmentTypeValues]);

  const condition_type_options = [
    { value: 'generic', label: 'Generic' },
    { value: 'specialized', label: 'Specialized' },
  ];

  useEffect(() => {
    if (getAllSpecialtiesList && Array.isArray(getAllSpecialtiesList)) {
      let dataArr = [];
      getAllSpecialtiesList.forEach((key) => {
        dataArr.push({
          value: key?.specialty_id,
          label: key?.specialty_name,
        });
      });
      setSpecialtyOptions(dataArr);
    }
  }, [getAllSpecialtiesList]);

  const handleRadioButton = (e) => {
    const selectedAppointmentTypeId = e.target.value;
    setRadioButtonvalue(selectedAppointmentTypeId);
  };

  const handleConditionChange = (setFieldValue, value) => {
    setFieldValue('specialty_id', value);
    setStoreSpecialtyId(value);
  };

  const initialValues = {
    specialty_id: getConditionById?.specialty_name
      ? getConditionById?.specialty_name
      : '',
    condition_name: getConditionById?.condition_name
      ? getConditionById?.condition_name
      : 'N/A',
    condition_type: getConditionById?.condition_type
      ? getConditionById?.condition_type
      : 'N/A',
    appointment_type_id: getConditionById?.appointment_type_id
      ? getConditionById?.appointment_type_id
      : 1,
  };

  const validationSchemaField = Yup.object().shape({
    specialty_id: Yup.string().required('Specialty is required'),
    condition_type: Yup.string().required('Condition type is required'),
    condition_name: Yup.string().required('Condition name is required'),
  });

  const sections = [
    {
      heading: 'Edit condition',
      fields: [],
    },
    {
      heading: 'radio_group',
      className: 'grid grid-cols-3 gap-4',
      fields: [
        {
          name: 'condition_name',
          type: 'text',
          title: 'Condition name',
          placeholder: 'Type condition',
        },
        {
          name: 'specialty_id',
          type: 'select',
          title: 'Specialty name',
          placeholder: 'Select specialty',
          options: specialtyOptions,
          onChange: (setFieldValue, value) =>
            handleConditionChange(setFieldValue, value),
        },
        {
          name: 'condition_type',
          type: 'select',
          title: 'Condition type',
          placeholder: 'Select condition type',
          options: condition_type_options,
          onChange: (setFieldValue, e) => {
            setStoreConditionType(e);
            setFieldValue('condition_type', e);
          },
        },
      ],
    },
  ];

  return (
    <SuperAdminModal
      open={isOpen}
      sections={sections}
      closable={false}
      initialValues={initialValues}
      validationSchema={validationSchemaField}
      submitButtonText="Submit"
      cancelButtonText="Cancel"
      className={'feedback-modal'}
      handleCancel={() => {
        setIsOpen(false);
      }}
      radioButtonValue={radioButtonValue}
      appointmentTypes={appointmentTypes}
      handleRadioButton={handleRadioButton}
      handleSubmit={(values) => {
        const payload = {
          condition_name: values?.condition_name,
          appointment_type_id: radioButtonValue,
          specialty_id: storeSpecialtyId
            ? storeSpecialtyId
            : values?.specialty_id
              ? getConditionById?.specialty_id
              : storeSpecialtyId,
          condition_type: values?.condition_type,
          last_modified_by: cachedUserEmail,
        };
        dispatch(
          editConditionByIdAction(
            getConditionById?.condition_id,
            payload,
            setIsOpen,
            isfilterOn,
            filterValue
          )
        );
      }}
    />
  );
};

export default EditCondition;
